module.exports = __webpack_public_path__ + "img/zhongdaanjian.4c275ca9.png";